(async () => {
	const updateCartAttributes = async (attributes) => {
		const resp = await fetch('/cart/update.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ attributes })
		});

		if (resp.ok)
			return resp.json();
		else
			throw new Error(`HTTP error: ${resp.status}`);
	};

	try {
		let info;

		if (window.location.search) {
			const params = new URLSearchParams(window.location.search);
			if (params.size) {
				info = Object.fromEntries(params);
				localStorage.setItem('affiliateTrackerInfo', JSON.stringify(info));
			}
		}

		if (!info && sessionStorage.getItem('affiliateTrackerStatus') === null) {
			const json = localStorage.getItem('affiliateTrackerInfo');
			if (json)
				info = JSON.parse(json);
		}

		if (info) {
			const data = await updateCartAttributes({ ...info });
			console.log('Updated cart:', data);
		}

		sessionStorage.setItem('affiliateTrackerStatus', 'done');
	}
	catch (err) {
		console.error('Error updating cart attributes:', err);
	}
}).call();
